import { Link } from "react-router-dom";

const entries = [
  { label: "电影", icon: "ri-film-line", to: "/category/movie" },
  { label: "电视剧", icon: "ri-tv-line", to: "/category/tvseries" },
  { label: "国产", icon: "ri-home-heart-line", to: "/category/china" },
  { label: "海外", icon: "ri-earth-line", to: "/category/overseas" },
  { label: "日韩", icon: "ri-leaf-line", to: "/category/japankorea" },
  { label: "最新", icon: "ri-time-line", to: "/category/latest" },
  { label: "热门专题", icon: "ri-fire-line", to: "/category/hot" },
];

export default function CategoryQuickLinks() {
  return (
    <div className="flex flex-wrap gap-3">
      {entries.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 hover:text-accent-500 hover:border-accent-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={`${item.icon} text-lg text-accent-500`}></i>
          {item.label}
        </Link>
      ))}
    </div>
  );
}